<template>
  <div>
    <general-top-bar :title="$t('reports.waiterTipsReport')"></general-top-bar>
    <div class="sales-report waiter-tips-report">
      <div class="row mar-bt-15">
        <div class="col-md-4">
          <div class="mb-3 w-100">
            <label class="form-label text-start w-100">{{$t('dashboard.selectLocation')}}</label>
            <select class="form-control mar-bt-15" v-model="orders.location">
              <option value="" selected :label="$t('general.all')">{{$t('general.all')}}</option>
              <option
                v-for="loc in locations"
                :key="loc.id"
                :label="loc.name"
                :value="loc.id">{{loc.name}}</option>
            </select>
          </div>
        </div>
        <div class="col-md-4">
          <div class="mb-3 w-100">
            <label class="form-label text-start w-100">{{$t('reports.waiterTipsMode')}}</label>
            <select class="form-control mar-bt-15" v-model="reportMode">
              <option value="waiter">{{$t('reports.waiterTipsModeWaiter')}}</option>
              <option value="delivery">{{$t('reports.waiterTipsModeDelivery')}}</option>
            </select>
          </div>
        </div>
        <div class="col-md-4">
          <div class="mb-3 w-100">
            <label class="form-label text-start w-100">{{ personFilterLabel }}</label>
            <v-select
              v-model="selectedWaiters"
              :options="waiterOptions"
              multiple
              :placeholder="$t('general.alls')">
            </v-select>
          </div>
        </div>
      </div>

      <div class="col-md-12">
        <p class="pull-left">
          <el-date-picker
            type="daterange"
            v-model="orders.valid"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            :name="pickerNames"
            :picker-options="pickerOptions">
          </el-date-picker>
          <div
            class="pull-left"
            style="display: flex; align-items: center; justify-content: center; margin-left: 10px;">
            {{$t('general.from')}}
            <el-time-select
              :placeholder="$t('catalogProd.timePlaceholder')"
              v-model="valid_from"
              style="margin-left: 10px;"
              class="mar-rt-5"
              :picker-options="{
                start: '00:00',
                step: '00:10',
                end: '24:00'
              }">
            </el-time-select>
            {{$t('general.to')}}
            <el-time-select
              :placeholder="$t('catalogProd.timePlaceholder')"
              v-model="valid_to"
              class="mar-lt-5"
              :picker-options="{
                start: '00:00',
                step: '00:10',
                end: '24:00'
              }">
            </el-time-select>
          </div>
        </p>
        <div class="pull-left search-button-reports">
          <div :title="$t('reports.search')" class="btn btn-icon btn-info btn-search" @click="updateData">
            <i class="ti-search"></i>
          </div>
        </div>
        <div class="search-button-reports form-group pull-left">
          <div :title="$t('reports.export')" class="btn btn-icon btn-xls-slim" @click="exportData()">
            {{$t('general.download_xls') }} <img src="/static/img/export_xls.png">
          </div>
        </div>
      </div>

      <div class="col-md-12">
        <p style="text-align:left; margin: 20px 0px;">
          {{ $t('reports.filteredData') }}
          <b>{{orders.valid[0]}} {{valid_from}}:00</b> - <b>{{orders.valid[1]}} {{valid_to}}:59</b>
        </p>
      </div>

      <div class="row mar-bt-15 waiter-tips-summary" v-loading="loading">
        <div class="col-md-4 col-sm-6">
          <div class="waiter-tips-stat">
            <div class="waiter-tips-stat-label">{{$t('reports.tips')}}</div>
            <div class="waiter-tips-stat-value">{{formatMoneyAmount(Number(displayedTotals.total_tips || 0))}}</div>
          </div>
        </div>
        <div class="col-md-4 col-sm-6">
          <div class="waiter-tips-stat">
            <div class="waiter-tips-stat-label">{{$t('reports.ordersNumber')}}</div>
            <div class="waiter-tips-stat-value">{{displayedTotals.order_count || 0}}</div>
          </div>
        </div>
        <div class="col-md-4 col-sm-6">
          <div class="waiter-tips-stat">
            <div class="waiter-tips-stat-label">{{$t('reports.waiterTipsZRange')}}</div>
            <div class="waiter-tips-stat-value">{{zRangeLabel}}</div>
          </div>
        </div>
      </div>

      <div class="col-md-12">
        <div class="waiter-tips-sheet" v-loading="loading">
          <template v-if="!loading && !filteredWaiters.length">
            <div class="no-data-message" style="text-align: center; margin: 20px;">
              <h3>{{ $t('reports.noDataAvailable') }}</h3>
            </div>
          </template>
          <table v-else class="waiter-tips-table">
            <thead>
              <tr>
                <th class="col-name">{{$t('reports.waiterTipsUserName')}}</th>
                <th class="col-count">#</th>
                <th class="col-value">{{$t('reports.waiterTipsValue')}}</th>
              </tr>
            </thead>
            <tbody v-for="waiter in pagedWaiters" :key="waiter.waiter_id">
              <tr class="waiter-group-header">
                <td colspan="3">{{ waiter.waiter_name }}</td>
              </tr>
              <tr
                v-for="(method, methodIndex) in waiter.payment_methods"
                :key="'method-' + waiter.waiter_id + '-' + methodIndex"
                class="waiter-method-row"
                :class="methodIndex % 2 === 0 ? 'is-even' : 'is-odd'">
                <td class="col-name method-label">{{ paymentLabel(method.payment_type) }}</td>
                <td class="col-count">{{ method.order_count }}</td>
                <td class="col-value">{{ formatTips(method.total_tips) }}</td>
              </tr>
              <tr class="waiter-subtotal-row">
                <td class="col-name">{{ waiter.waiter_name }}</td>
                <td class="col-count">{{ waiter.total && waiter.total.order_count }}</td>
                <td class="col-value">{{ formatTips(waiter.total && waiter.total.total_tips) }}</td>
              </tr>
            </tbody>
            <tbody v-if="filteredWaiters.length">
              <tr class="waiter-grand-total-row">
                <td class="col-name">{{$t('reports.total')}}:</td>
                <td class="col-count">{{ displayedTotals.order_count }}</td>
                <td class="col-value">{{ formatTips(displayedTotals.total_tips) }}</td>
              </tr>
            </tbody>
          </table>
          <div class="waiter-tips-pagination" v-if="filteredWaiters.length">
            <el-pagination
              background
              layout="prev, pager, next, sizes, total"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="pageSize"
              :current-page="currentPage"
              :total="filteredWaiters.length"
              @current-change="handlePageChange"
              @size-change="handleSizeChange">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {DatePicker} from 'element-ui'
import moment from 'moment'
import swal from 'sweetalert2'
import GeneralTopBar from 'src/components/UIComponents/Inputs/generalTopBar.vue'

export default {
  components: {
    GeneralTopBar,
    [DatePicker.name]: DatePicker
  },
  props: {
    isWaiterTips: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    isWaiterTips: {
      immediate: true,
      handler (isActive) {
        if (isActive) {
          this.verifyUserLocations()
          this.getPosUsers()
          this.getDrivers()
          this.getOrders()
        }
      }
    },
    selectedWaiters () {
      this.currentPage = 1
    },
    reportMode () {
      this.selectedWaiters = []
      this.currentPage = 1
      if (this.isWaiterTips) {
        this.getOrders()
      }
    }
  },
  computed: {
    isDeliveryMode () {
      return this.reportMode === 'delivery'
    },
    personFilterLabel () {
      return this.isDeliveryMode
        ? this.$t('reports.waiterTipsSelectDrivers')
        : this.$t('reports.waiterTipsSelectWaiters')
    },
    waiterOptions () {
      if (this.isDeliveryMode) {
        if (this.waiters.length) {
          return this.waiters.map(waiter => ({
            value: waiter.waiter_id,
            label: waiter.waiter_name
          }))
        }
        return this.rawDrivers.map(user => ({
          value: user.id,
          label: `${user.firstname} ${user.lastname}`
        }))
      }

      if (this.waiters.length) {
        return this.waiters.map(waiter => ({
          value: waiter.waiter_id,
          label: waiter.waiter_name
        }))
      }
      return this.rawPosUsers.map(user => ({
        value: user.id,
        label: `${user.firstname} ${user.lastname}`
      }))
    },
    selectedWaiterIds () {
      if (!this.selectedWaiters || !this.selectedWaiters.length) {
        return []
      }
      return this.selectedWaiters.map(waiter => String(waiter.value))
    },
    filteredWaiters () {
      if (!this.selectedWaiterIds.length) {
        return this.waiters
      }
      return this.waiters.filter(waiter => this.selectedWaiterIds.indexOf(String(waiter.waiter_id)) !== -1)
    },
    pagedWaiters () {
      const start = (this.currentPage - 1) * this.pageSize
      return this.filteredWaiters.slice(start, start + this.pageSize)
    },
    displayedTotals () {
      if (!this.selectedWaiterIds.length) {
        return this.totals
      }
      return this.filteredWaiters.reduce((acc, waiter) => {
        acc.order_count += Number((waiter.total && waiter.total.order_count) || 0)
        acc.total_tips += Number((waiter.total && waiter.total.total_tips) || 0)
        return acc
      }, { order_count: 0, total_tips: 0 })
    },
    zRangeLabel () {
      if (this.zRange.min == null && this.zRange.max == null) {
        return '—'
      }
      if (this.zRange.min === this.zRange.max) {
        return String(this.zRange.min)
      }
      return (this.zRange.min || '—') + ' – ' + (this.zRange.max || '—')
    }
  },
  data () {
    return {
      valid_from: '00:00',
      valid_to: '23:59',
      loading: false,
      reportMode: 'waiter',
      waiters: [],
      selectedWaiters: [],
      rawPosUsers: [],
      rawDrivers: [],
      currentPage: 1,
      pageSize: 20,
      totals: {
        order_count: 0,
        total_tips: 0
      },
      zRange: {
        min: null,
        max: null
      },
      period: {
        from: '',
        to: ''
      },
      orders: {
        valid: [
          moment().date(1).format('YYYY-MM-DD'),
          moment().format('YYYY-MM-DD')
        ],
        location: ''
      },
      locations: [],
      showLocations: false,
      pickerNames: ['date_from', 'date_to'],
      pickerOptions: {
        disabledDate (date) {
          return date < moment().subtract(12, 'months').startOf('day') || date > moment().endOf('day')
        }
      }
    }
  },
  methods: {
    paymentLabel (type) {
      if (!type) return ''
      const key = 'paymentTypes.' + type
      return this.$te(key) ? this.$t(key) : type
    },
    formatTips (amount) {
      const value = Number(amount || 0).toFixed(2)
      const parts = value.split('.')
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      return parts.join('.')
    },
    normalizePeople (responseData) {
      if (this.isDeliveryMode) {
        return (responseData.drivers || []).map(driver => ({
          waiter_id: driver.driver_id,
          waiter_name: driver.driver_name,
          payment_methods: driver.payment_methods || [],
          total: driver.total || { order_count: 0, total_tips: 0 }
        }))
      }
      return responseData.waiters || []
    },
    changeValidFrom () {
      if (!this.valid_from) {
        this.valid_from = '00:00'
      }
      if (!this.valid_to) {
        this.valid_to = '23:59'
      }
    },
    verifyUserLocations () {
      const companyData = this.$session.get('selectedCompanyData') || {}
      const details = companyData.locations_details || []
      this.locations = details.map(location => ({
        id: location.true_id != null ? location.true_id : location.id,
        name: location.name
      })).filter(location => location.id != null)

      if (!this.isOwner()) {
        let allowedLocations = []
        try {
          allowedLocations = JSON.parse(this.$session.get('userDataLocations') || '[]') || []
        } catch (e) {
          allowedLocations = []
        }
        if (allowedLocations.length === 0) {
          this.locations.forEach((element) => {
            allowedLocations.push(element.id)
          })
        }
        this.locations = this.locations.filter(function (el) {
          return allowedLocations.some(id => String(id) === String(el.id))
        })
      }

      let filterCookie = this.$cookie.get('filter-locations')
      if (filterCookie) {
        filterCookie = JSON.parse(filterCookie)
        this.orders.location = filterCookie[0]
      }
    },
    getRequestData () {
      this.changeValidFrom()
      if (this.valid_to === '24:00') {
        this.valid_to = '23:59'
      }
      if (this.valid_from === '24:00') {
        this.valid_from = '23:59'
      }

      const data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        from_date: this.orders.valid[0],
        to_date: this.orders.valid[1],
        start_date: this.orders.valid[0] + ' ' + this.valid_from + ':00',
        end_date: this.orders.valid[1] + ' ' + this.valid_to + ':59'
      }

      if (this.orders.location && this.orders.location !== '') {
        data.location_id = this.orders.location
      }

      if (this.isDeliveryMode) {
        data.mode = 'delivery'
        if (this.selectedWaiterIds.length) {
          data.driver_ids = this.selectedWaiterIds
        }
      } else if (this.selectedWaiterIds.length) {
        data.waiter_ids = this.selectedWaiterIds
      }

      return data
    },
    getOrders () {
      if (!this.isWaiterTips) {
        return
      }

      this.loading = true
      this.apiRequest('/reports/v2/waiter-tips', 'GET', this.getRequestData(), (response) => {
        if (response.status && response.data) {
          this.waiters = this.normalizePeople(response.data)
          this.totals = response.data.total || { order_count: 0, total_tips: 0 }
          this.zRange = response.data.z_range || { min: null, max: null }
          this.period = response.data.period || { from: '', to: '' }
          this.currentPage = 1
        } else {
          this.waiters = []
          this.totals = { order_count: 0, total_tips: 0 }
          this.zRange = { min: null, max: null }
          swal(
            '',
            response.errors && response.errors['id'] ? response.errors['id'] : this.$t('validations.wentWrong'),
            'error'
          )
        }
        this.$nextTick(() => {
          this.loading = false
        })
      })
    },
    updateData () {
      this.getOrders()
      this.$cookie.set('filter-locations', JSON.stringify([this.orders.location]), 30)
    },
    exportData () {
      this.loading = true
      this.apiRequest('/reports/v2/waiter-tips-download', 'GET', this.getRequestData(), (response) => {
        if (response.status === true && response.data) {
          const link = document.createElement('a')
          link.href = response.data.file
          link.setAttribute('download', response.data.file_name)
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        } else {
          swal(
            '',
            response.errors && response.errors['id'] ? response.errors['id'] : this.$t('validations.wentWrong'),
            'error'
          )
        }
        this.loading = false
      })
    },
    handlePageChange (page) {
      this.currentPage = page
    },
    handleSizeChange (size) {
      this.pageSize = size
      this.currentPage = 1
    },
    getPosUsers () {
      const data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      }

      this.apiRequest('/pos/all/users', 'GET', data, (response) => {
        if (response.status) {
          this.rawPosUsers = response.data.pos_user || []
        }
      })
    },
    getDrivers () {
      const data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      }

      this.apiRequest('/reports/drivers-list', 'GET', data, (response) => {
        if (response.status) {
          this.rawDrivers = response.data.drivers || response.data || []
        }
      })
    }
  }
}
</script>

<style scoped>
.waiter-tips-summary {
  margin-left: 0;
  margin-right: 0;
}

.waiter-tips-stat {
  background: #FBFCFF;
  border: 1px solid #E6E9FF;
  border-radius: 12px;
  padding: 16px 18px;
  min-height: 92px;
  box-shadow: 0 1px 2px rgba(18, 38, 63, 0.04);
}

.waiter-tips-stat-label {
  font-weight: 700;
  color: #25396F;
  font-size: 13px;
  letter-spacing: 0.01em;
}

.waiter-tips-stat-value {
  font-weight: 800;
  color: #25396F;
  font-size: 22px;
  margin-top: 8px;
}

.waiter-tips-sheet {
  background: #fff;
  width: 100%;
  padding: 8px 0 24px;
}

.waiter-tips-table {
  width: 100%;
  border-collapse: collapse;
  color: #111;
  font-size: 14px;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
}

.waiter-tips-table th,
.waiter-tips-table td {
  padding: 8px 16px;
  vertical-align: middle;
}

.waiter-tips-table thead th {
  border: 1px solid #111;
  font-weight: 600;
  background: #fff;
}

.waiter-tips-table .col-name {
  text-align: left;
  width: 58%;
}

.waiter-tips-table .col-count {
  text-align: center;
  width: 12%;
}

.waiter-tips-table .col-value {
  text-align: right;
  width: 30%;
  font-variant-numeric: tabular-nums;
}

.waiter-group-header td {
  padding-top: 14px;
  padding-bottom: 4px;
  font-weight: 400;
}

.waiter-method-row td {
  padding-top: 6px;
  padding-bottom: 6px;
  border: none;
}

.waiter-method-row.is-even td {
  background: #EEF3FF;
}

.waiter-method-row.is-odd td {
  background: #F7F8FA;
}

.waiter-method-row .method-label {
  padding-left: 36px;
}

.waiter-subtotal-row td {
  font-weight: 700;
  border-top: 1px solid #111;
  border-bottom: 1px solid #111;
  padding-top: 6px;
  padding-bottom: 6px;
}

.waiter-grand-total-row td {
  font-weight: 700;
  border-top: 1px solid #111;
  padding-top: 10px;
}

.waiter-tips-pagination {
  display: flex;
  justify-content: center;
  margin-top: 16px;
}

@media print {
  .report-toolbar,
  .search-button-reports,
  .waiter-tips-summary {
    display: none !important;
  }

  .waiter-tips-sheet {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Reports/Versions/2/WaiterTipsReport.vue